<template>
  <div class="outterBox">
    <div class="topHeader" @click="headerClicked">
      <span class="headerText">안내사항</span>
      <div class="chevronDiv" v-show="isMobile">
        <b-icon icon="chevron-up" scale="1" v-show="isShow" />
        <b-icon icon="chevron-down" scale="1" v-show="!isShow" />
      </div>
    </div>
    <TransitionCollapseHeight v-show="isShow">
      <div class="content">
        <table class="table table-borderless">
          <tbody>
            <tr>
              <th class="tdSpace">기본사항</th>
              <td class="tdContent">
                ※ 희망일자, 인원수, 메인, 추가옵션은 필수 선택사항 입니다.<br />
                ※ 세부요청사항 : 별도 희망일자, 영유아동반여부(인원, 연령), 보호자 인원 (키즈승마 한정) 등 기타요청사항
              </td>
            </tr>
            <tr>
              <th class="tdSpace">이용안내</th>
              <td class="tdContent">
                본 페이지는 P-Leisure(핀크스 레저) 예약신청 페이지입니다.<br />
                기재해주신 정보를 토대로 예약 내용 확인 후 확정 안내 드립니다.<br />
                신청 접수 후에는 예약 확정을 위하여 기재해주신 연락처로 전화 회신 드리오니, 반드시 연락 가능한
                전화번호로 기재 바랍니다.<br />
                모든 예약은 7일 전 예약을 원칙으로 합니다.<br />
                ※ 모든 프로그램은 여행자보험이 포함되어 있습니다. 가입을 위하여 예약일 전 유선 연락 드리오니, 받아주시고
                응답 부탁드립니다.<br />
                ※ 프로그램 이용료는 5세 이상부터 적용 됩니다.
              </td>
            </tr>
            <tr>
              <th class="tdSpace">문의 및 상담</th>
              <td class="tdContent">예약문의 및 상담 : 064-793-7070, 010-5328-7050, pinxleisure@sk.com</td>
            </tr>
          </tbody>
        </table>
      </div>
    </TransitionCollapseHeight>
  </div>
</template>

<script>
import TransitionCollapseHeight from '@/components/TransitionCollapseHeight';
export default {
  name: 'ReserveInfo',
  components: {TransitionCollapseHeight},
  data() {
    return {
      isMobile: false,
      isShow: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
      this.onResize();
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    headerClicked() {
      if (window.innerWidth < 992) {
        this.isShow = !this.isShow;
      }
    },
    onResize() {
      console.log('SLIDER-ON-RESIZE', window.innerWidth);
      this.isMobile = window.innerWidth < 992;
      if (window.innerWidth > 992) {
        this.isShow = true;
      }

      // if (window.innerWidth > 992) {
      //   this.isShow = true;
      // } else {
      //   this.isShow = false;
      // }
      // this.isMobile = window.innerWidth <= 992;
      // this.height = window.innerWidth * 0.5;
    },
  },
};
</script>

<style scoped lang="scss">
.outterBox {
}
.topHeader {
  display: flex;
  padding-top: 1rem;
  padding-left: 0rem;

  font-weight: bold;
  font-size: 1.3rem;

  margin-bottom: 1rem;
}
.top {
  display: flex;
  padding: 1rem 1.2rem;
}
th,
td {
  border-bottom: 1px solid #e3e3e3;
  display: table-cell;

  line-height: 2rem;
  vertical-align: middle;
}
ol.rounded-list {
  //  counter-reset: li;
  //  list-style: none;
  padding: 0;
}
span {
  text-align: center;
  font-weight: bold;
}
.infoDetail {
  position: relative;
  display: block;
  height: 1.5em;
  line-height: 2.5rem;
  letter-spacing: -0.02rem;
  font-size: 0.9rem;
}

.trSpace {
  border-top: 1px solid #e3e3e3;
}

.tdSpace {
  width: 15%;
  text-align: center;
  font-size: 0.9rem;
}

.tdContent {
  font-size: 0.9rem;
  word-break: keep-all;
}

@media (max-width: 992px) {
  .topHeader {
    padding-top: 1rem;
    padding-left: 0rem;
    padding-bottom: 0rem;

    font-weight: bold;
    font-size: 1.3rem;
    width: 100%;

    &:hover {
    }

    .chevronDiv {
      margin-left: auto;
    }
  }

  .tdSpace {
    width: 90px;
    font-size: 0.9rem;
  }

  .content {
    padding-left: 0rem;
    padding-bottom: 2rem;
  }
  .tdContent {
    font-size: 0.8rem;
    line-height: 1.5rem;
    word-break: keep-all;
  }
}
</style>
